import { GraphQLError, GraphQLScalarType, Kind } from "graphql";

//#region src/custom-scalars/ncpdp-id.scalar.ts
const NCPDP_ID_REGEX = /^\d{7}$/;
const ncpdpIdScalar = new GraphQLScalarType({
	name: "NCPDPID",
	description: "NCPDPID custom scalar type",
	serialize: (value) => {
		if (!(typeof value === "string")) throw new GraphQLError(`GraphQL serializer expected a 'string' but got ${typeof value}.`, { extensions: { code: "400" } });
		return validateNcpdpId(value);
	},
	parseValue: (value) => {
		if (!(typeof value === "string")) throw new GraphQLError(`GraphQL parser expected a 'string' but got ${typeof value}.`, { extensions: { code: "400" } });
		return validateNcpdpId(value);
	},
	parseLiteral(ast) {
		if (ast.kind === Kind.STRING) return ast.value.toString();
		throw new GraphQLError(`GraphQL parser expected a 'string'.`, { extensions: { code: "400" } });
	}
});
function validateNcpdpId(value) {
	if (!isValidNcpdpId(value)) throw new GraphQLError(`Provided value: ${value}, is not a valid ncpdp id.`, { extensions: { code: "BAD_USER_INPUT" } });
	return value;
}
const isValidNcpdpId = (value) => NCPDP_ID_REGEX.test(value);

//#endregion
export { isValidNcpdpId, ncpdpIdScalar };